module.exports = __webpack_public_path__ + "static/sungrown-logo-967e9d7a5afd2dcd134141f8045083d6.svg";